import BulmaIcon from './component/icon.vue';
import BulmaDropdown from './component/dropdown.vue';
var Bulma = /** @class */ (function () {
    function Bulma() {
    }
    Bulma.install = function (Vue) {
        Vue.component('bulma-icon', BulmaIcon);
        Vue.component('bulma-dropdown', BulmaDropdown);
    };
    return Bulma;
}());
export default Bulma;
